/**
 * @fileoverview GET handler for the "/engagement/campaigns/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementCampaignsTagsWithIds } from "./constants";
import type { EngagementCampaignsTagsWithIdsResult } from "./types";

export const getEngagementCampaignsTagsWithIds = reactQueryFetcherAdapter(
  engagementCampaignsTagsWithIds,
  (signal: AbortSignal): Promise<EngagementCampaignsTagsWithIdsResult> => {
    return fetch("/engagement/campaigns/tags_with_ids", "GET", {}, { signal });
  }
);
